import config from '../../config/config';

import getRequest from './base/get';
import postRequest from './base/post';

/**
 * QR API Service for fetching proxy URL details.
 */
const qrApi = {
  /**
   * Get proxy URL details by EVSE ID.
   * @param {string} evseId - The EVSE ID to resolve.
   * @returns {Promise<any>} The response containing the proxy URL and short code.
   */
  getProxyUrlByEvseId: (evseId: string): Promise<any> => {
    return getRequest(`${config.proxyApiUrl}api/v1/qr/evse/${evseId}`);
  },

  /**
   * Get proxy URL details in bulk by EVSE IDs.
   * @param {string[]} evseIds - Array of EVSE IDs.
   * @returns {Promise<any>} The response containing the array of proxy URLs.
   */
  getProxyUrlsByEvseIds: (evseIds: string[]): Promise<any> => {
    return postRequest(`${config.proxyApiUrl}api/v1/qr/evse`, { evseIds });
  },

  /**
   * Get QR configuration details (including existing connection/tenant mapping).
   * @param {string} evseId - The EVSE ID.
   * @returns {Promise<any>} The response containing the QR config.
   */
  getQrConfigByEvseId: (evseId: string): Promise<any> => {
    return getRequest(`${config.proxyApiUrl}api/v1/qr/config/${evseId}`);
  },

  /**
   * Save or update the QR configuration for an EVSE.
   * @param {any} payload - The configuration data (e.g. { evseId, connectionId, ... })
   * @returns {Promise<any>} The save response.
   */
  saveQrConfig: (payload: any): Promise<any> => {
    return postRequest(`${config.proxyApiUrl}api/v1/qr/config`, payload);
  },
};

export default qrApi;
